import { IdentityProvider } from 'types/types/IdentityProvider'
import { IAddress } from './IAddress'

export interface IPersonalDetails {
  id?: string // id (teudat zehut)
  identityProvider?: IdentityProvider
  dob?: string
  phoneNum?: string
  firstName?: string
  lastName?: string
  addresses?: IAddress[]
  gender?: GenderIdentity
  issueAge?: number
  description?: string
  segments?: string[]
  name?: string
  playerImage?: number
  seenMarketingMessage?: boolean
}

export enum AccountType {
  Analyst = 'Analyst',
  Competitor = 'Competitor',
  Customer = 'Customer',
  Integrator = 'Integrator',
  Investor = 'Investor',
  Partner = 'Partner',
  Press = 'Press',
  Prospect = 'Prospect',
  Reseller = 'Reseller',
  Other = 'Other',
}

export enum GenderIdentity {
  MALE = 'Male',
  FEMALE = 'Female',
  OTHER = 'Other',
}

export enum IUserFrom {
  SIGN_UP = 'SIGN_UP',
  LOGIN = 'LOGIN',
}
